import React from 'react'
import './Enrollaction.css'
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
library.add(fas)

const Enrollaction = () => {
  return (
    <div class="call-action-2 ws-section bg-2 pb-05 dark-bg">
        <div class="container text-center">
                    <div class="row dark-bg mb-lg-5">
                        <div class="col-lg">
                            <h2 class="ws-section_heading pd-03 mb-1">Shape the Future of Electronics </h2>
                            <h3>Enrol in Our Premier VLSI Programs Today</h3>
                        </div>
                    </div>
                    <div class="row">
                        <div class="p-2 col-lg">
                             <a href="/register-now/">
                            <button class="btn-secondary btn-icon btn-outline-lt" href="#about">Enrol Now<FontAwesomeIcon icon="fa-solid fa-circle-arrow-right" /></button>
                            </a>
                        </div>
                    </div>
                    <div class="row g-3 mt-lg-5 pt-5 justify-content-end">
                        <div class="col-lg-5 text-lg-end">
                            <h4 class="bottom-title">Get In Touch:</h4>
                            <div class="bottom-sub-title">info@takshila-vlsi.com</div>
                        </div>
                        <div class="col-lg-2">
                            <h2 class="bottom-center">or</h2>
                        </div>
                        <div class="col-lg text-lg-start">
                            <h4 class="bottom-title">Call / WhatsApp Us Via:</h4>
                            <div class="bottom-sub-title">+91-974 2972 744</div>
                        </div>
                    </div>
                </div>
    </div>
  )
}

export default Enrollaction